export const debugPlaybackEnabled = () => {
  try {
    if (typeof window === 'undefined') return false;
    const fromStorage = window.localStorage.getItem('debugPlayback');
    if (fromStorage === '1' || fromStorage === 'true') return true;
    const qs = new URLSearchParams(window.location.search);
    return qs.get('debugPlayback') === '1';
  } catch (err) {
    return false;
  }
};

export const debugPlaybackLog = (...args) => {
  if (!debugPlaybackEnabled()) return;
  // eslint-disable-next-line no-console
  console.log('[DEBUG_PLAYBACK]', ...args);
};

export const createScanId = (deviceId = 'unknown') => {
  try {
    return `${deviceId}-${Date.now()}-${Math.random().toString(16).slice(2, 8)}`;
  } catch (err) {
    return `${deviceId}-${Date.now()}`;
  }
};
